'use strict';

// Constructor
var CollapsibleBox = function() {
  $('.collapsible-box .toggle').click(function($event) {
      $event.preventDefault();
      $(this).closest('.collapsible-box').toggleClass('expanded');
  });
};

module.exports = CollapsibleBox;
